module.exports = __webpack_public_path__ + "img/header-memoireRingsConfigurator.cd8e029.webp";